import request from '@/utils/request'

// 获取查看或下载文件路径 key
export function getFileUrl(data) {
	return request({
		url: 'case/file/getFileUrl',
		method: 'get',
		params: data
	})
}